import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";

export const HiveTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    
    @media screen and (max-width: 1000px) {
        height: 54px;
        width: 100%;
        //justify-content: space-between;
        justify-content: center;
    }
`

export const HiveArrowWrapper = styled.div`
    width: 24px;
    height: 24px;
    
    cursor: pointer;
    
    &:first-of-type {
        transform: rotate(180deg);
    }
    
    svg {
        width: 100%;
        height: 100%;
        
        path {
            fill: var(--fg-default, rgba(16, 24, 40, 1));
        }
    }
`

export const HiveTitleRentTag = styled.div`
  padding: ${toRem(4)} ${toRem(8)};
  background-color: ${COLORS.STATUS_01.CONTAINER_DEFAULT};
  width: max-content;
  border-radius: ${toRem(8)};
  color: ${COLORS.STATUS_01.DEFAULT};
  font-weight: 500;
  font-size: ${toRem(12)};
  line-height: ${16 / 12};
`